import { VZButton } from 'components/Button/button.styles';
import styled, { css } from 'styled-components';
import { rem, tablet } from 'theme';

export const Heading = styled.h5`
  padding: ${rem(16)} ${rem(16)} ${rem(16)} ${rem(32)};

  font-size: var(--sys-font-size-lg);
  font-style: normal;
  font-weight: var(--ref-font-weight-600);
  line-height: 24px;
`;

export const Content = styled.div`
  flex: 1;

  padding: ${rem(32)};

  border-top: solid 2px var(--ref-color-gray-30);
  border-bottom: solid 2px var(--ref-color-gray-30);

  a:hover {
    text-decoration: underline;
  }

  h4 {
    padding-bottom: ${rem(8)};
  }
`;

export const Section = styled.div`
  display: flex;
  height: calc(100vh - ${rem(2)});

  &:last-child {
    padding: 0;
  }

  flex-direction: column;

  ${tablet(css`
    height: auto;
  `)}
`;

export const Actions = styled.div`
  padding: ${rem(16)};
`;

export const Button = styled(VZButton)<{ isFullWidth?: boolean }>`
  width: ${(b) => (b.isFullWidth ? '100%' : 'auto')};

  &:first-child {
    margin-right: ${rem(8)};
  }
`;
